import { useId } from 'react';

type StarProps = {
  fillPercentage: number;
  index: number;
  className: string;
};

export function Star({ fillPercentage, index, className }: StarProps) {
  const uid = useId();
  const clipId = `star-clip-${index}-${uid}`;

  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id={clipId}>
          <rect x="0" y="0" width={`${fillPercentage}%`} height="100%" />
        </clipPath>
      </defs>
      <path
        fill="#e5e5e5"
        d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
      />
      <path
        fill="#ea771a"
        clipPath={`url(#${clipId})`}
        d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
      />
    </svg>
  );
}
